export { ContactView as default } from '../../views/contact';

export const getStaticProps = () => {
  return {
    props: {},
  };
};
